"use client";

import React from "react";
import { CircleCheck } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const listItems = ["Your home went through foreclosure", "Your property was sold at a tax sale", "You inherited property that was sold", "You lost property due to unpaid taxes", "You are a family member of a former homeowner"];
export default function AboutMe() {
  const {
    ref: contentRef,
    isVisible: isContentVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const {
    ref: imageRef,
    isVisible: isImageVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="227790" id="about" className="bg-background py-16 md:py-24 overflow-hidden">
      <div className="container mx-auto px-4 md:px-8 max-w-7xl">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-12 lg:gap-x-16 items-center">
          
          {}
          <div ref={contentRef} className={`flex flex-col transition-all duration-1000 ease-out ${isContentVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-8"}`}>
            
            <h2 className="text-4xl font-bold font-default mb-6 leading-tight !text-[hsl(224,76%,48%)] md:text-5xl">Who is this For?</h2>
            <p className="text-foreground/80 mb-6 leading-relaxed font-sans !text-2xl !font-bold">You May Qualify If:</p>

            <ul className="flex flex-col gap-y-4 mb-10">
              {listItems.map((item, i) => <li key={i} data-index={i} className="flex items-start gap-3">
                  <CircleCheck className="text-primary shrink-0 size-6 mt-0.5" />
                  <span className="text-foreground text-lg font-medium font-sans">{item}</span>
                </li>)}
            </ul>

            
          </div>

          {}
          <div ref={imageRef} className={`relative w-full transition-all duration-1000 delay-200 ease-out ${isImageVisible ? "opacity-100 translate-x-0" : "opacity-0 translate-x-8"}`}>
            
          </div>

        </div>
      </div>
    </section>;
}